import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

const baseSx = {
  width: "100%",
  height: "100%",
  maxWidth: "100%",
  maxHeight: "100%",
  minWidth: 0,
  minHeight: 0,
  boxSizing: "border-box",
  display: "grid",
  placeItems: "center",
  overflow: "hidden",
  p: 1,
} as const;

export default function DocumentImageViewport({
  src,
  alt,
  maxHeight = "100%",
  background = "#0d0e10",
  imageBackground,
  sx,
}: {
  src: string;
  alt: string;
  maxHeight?: string | number;
  background?: string;
  imageBackground?: string;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box sx={[{ ...baseSx, bgcolor: background }, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}>
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{
          display: "block",
          width: "auto",
          height: "auto",
          maxWidth: "100%",
          maxHeight,
          minWidth: 0,
          minHeight: 0,
          objectFit: "contain",
          bgcolor: imageBackground,
          borderRadius: 2,
        }}
      />
    </Box>
  );
}
